
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("j9yaG"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("j9yaG", function(module, exports) {

let $df195d4c7bc38468$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df195d4c7bc38468$var$load("h3ABO"),
    $df195d4c7bc38468$var$load("2fH0a"),
    $df195d4c7bc38468$var$load("OkWBV"),
    $df195d4c7bc38468$var$load("4jlMu"),
    $df195d4c7bc38468$var$load("2YffH"),
    $df195d4c7bc38468$var$load("2VmDq"),
    $df195d4c7bc38468$var$load("g7ggm"),
    $df195d4c7bc38468$var$load("6mHrv"),
    $df195d4c7bc38468$var$load("awWN9"),
    $df195d4c7bc38468$var$load("9CYct"),
    $df195d4c7bc38468$var$load("dJdZe"),
    $df195d4c7bc38468$var$load("lgOou"),
    $df195d4c7bc38468$var$load("hZtKG"),
    $df195d4c7bc38468$var$load("dkqvW"),
    $df195d4c7bc38468$var$load("lVO3w"),
    $df195d4c7bc38468$var$load("hyzoX"),
    $df195d4c7bc38468$var$load("h9Ed7"),
    $df195d4c7bc38468$var$load("eBRUf"),
    $df195d4c7bc38468$var$load("kbRvk"),
    $df195d4c7bc38468$var$load("tKhaz"),
    $df195d4c7bc38468$var$load("9Vh0G"),
    $df195d4c7bc38468$var$load("hBIgN"),
    $df195d4c7bc38468$var$load("cD6Zr"),
    $df195d4c7bc38468$var$load("k3jER"),
    $df195d4c7bc38468$var$load("9wzNh"),
    $df195d4c7bc38468$var$load("8YSo7"),
    $df195d4c7bc38468$var$load("9ldRJ"),
    $df195d4c7bc38468$var$load("50ame"),
    $df195d4c7bc38468$var$load("e7ZUf"),
    $df195d4c7bc38468$var$load("gL8bn"),
    $df195d4c7bc38468$var$load("1MlIV"),
    $df195d4c7bc38468$var$load("6iz6l"),
    $df195d4c7bc38468$var$load("4SCW2"),
    $df195d4c7bc38468$var$load("drp1W"),
    $df195d4c7bc38468$var$load("gb2Pz"),
    $df195d4c7bc38468$var$load("hv4mn"),
    $df195d4c7bc38468$var$load("Wowvf"),
    $df195d4c7bc38468$var$load("dek7I"),
    $df195d4c7bc38468$var$load("dYtBN"),
    $df195d4c7bc38468$var$load("kNV5Y"),
    $df195d4c7bc38468$var$load("6wr18"),
    $df195d4c7bc38468$var$load("kjZZD"),
    $df195d4c7bc38468$var$load("7cDV0"),
    $df195d4c7bc38468$var$load("ijD5W"),
    $df195d4c7bc38468$var$load("3JSgG"),
    $df195d4c7bc38468$var$load("37ldp"),
    $df195d4c7bc38468$var$load("ffEVr"),
    $df195d4c7bc38468$var$load("9AXkC"),
    $df195d4c7bc38468$var$load("28arV"),
    $df195d4c7bc38468$var$load("hhss7"),
    $df195d4c7bc38468$var$load("hvsDR"),
    $df195d4c7bc38468$var$load("9t4BV"),
    $df195d4c7bc38468$var$load("f1Pmi"),
    $df195d4c7bc38468$var$load("dP7ao"),
    $df195d4c7bc38468$var$load("hogcU"),
    $df195d4c7bc38468$var$load("5vfHd"),
    $df195d4c7bc38468$var$load("2Stk7"),
    $df195d4c7bc38468$var$load("7EorR"),
    $df195d4c7bc38468$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.f416d06a.js.map
